import { AuthPage } from "@-/dev.improve.haniverse.routes.nav.app.auth";

export default function AuthRoute() {
  return <AuthPage />;
}
